import * as React from 'react';
import { Checkin } from '@websky/core';
import { ThemeProvider } from '@websky/core/src/theme';
import { HashRouter } from 'react-router-dom';
import { RenderersProvider } from '@websky/core/src/renderProps';
import engineRenderers from '../../renderProps';
import theme from '../../theme/theme';
import '../../theme/variables.css';
import Head from '@websky/core/src/Head';
import CarouselStyles from '@websky/core/src/CarouselStyles/CarouselStyles';

const CheckinComponent: React.FC = () => {
	return (
		<HashRouter>
			<ThemeProvider value={theme}>
				<RenderersProvider value={engineRenderers}>
					<Head>
						<CarouselStyles />
					</Head>
					<Checkin />
				</RenderersProvider>
			</ThemeProvider>
		</HashRouter>
	);
};

export default CheckinComponent;
